import type {
  LiveEventUrlParams,
  MovieUrlParams,
  TvChannelUrlParams,
  TvShowEpisodeUrlParams,
  TvShowUrlParams,
} from '../index.h'

export const generateTvUrlParams = ({
  id,
  channelNumber,
  categoryId,
  featured,
  favorite,
  purchased,
  recommended,
  recentlyWatched,
}: TvChannelUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('channelId', String(id))

  if (categoryId >= 0) params.set('categoryId', String(categoryId))

  if (channelNumber) params.set('channelNumber', String(channelNumber))

  if (featured) params.set('featured', String(featured))

  if (favorite) params.set('favorite', String(favorite))

  if (purchased) params.set('purchased', String(purchased))

  if (recentlyWatched) params.set('recentlyWatched', String(recentlyWatched))

  if (recommended) params.set('recommended', String(recommended))

  return params.toString()
}

export const generateMovieUrlParams = ({ id }: MovieUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('vodId', String(id))

  return params.toString()
}

export const generateTvShowUrlParams = ({
  id,
  seasonId,
  episodeId,
  queryCategoryId,
  queryShowIndex,
}: TvShowUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('tvshowId', String(id))

  if (seasonId && seasonId >= 0) params.set('seasonId', String(seasonId))

  if (episodeId && episodeId >= 0) params.set('episodeId', String(episodeId))

  return `${params.toString()}${queryCategoryId}${queryShowIndex}`
}

export const generateTvShowEpisodeUrlParams = ({
  id,
  seasonId,
  tvShowId,
  queryCategoryId,
  queryShowIndex,
}: TvShowEpisodeUrlParams): string => {
  const params = new URLSearchParams()

  if (tvShowId && tvShowId >= 0) params.set('tvshowId', String(tvShowId))

  if (seasonId && seasonId >= 0) params.set('seasonId', String(seasonId))

  if (id >= 0) params.set('episodeId', String(id))

  return `${params.toString()}${queryCategoryId}${queryShowIndex}`
}

export const generateLiveEventUrl = ({ id }: LiveEventUrlParams): string => {
  const params = new URLSearchParams()

  if (id >= 0) params.set('liveEventId', String(id))

  return params.toString()
}
